<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { STATS } from '@/store/types';
import statsApi from '../../apis/stats.api';

export default {
  props: {
    type: {
      type: String,
      default: 'mile_share_trips',
    },
    from: String,
    to: String,
    daySearch: String,
  },

  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = statsApi.useMileShareQuery({
      type: props.type,
      from: props.from,
      to: props.to,
      daySearch: props.daySearch,
    });
    if (query.value) {
      store.commit(STATS.SET_MILE_MONTH_STATS_QUERY, query);
    }
    return { query };
  },
};
</script>
